import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';

// Pagina final do login pelo plugin.
//
// O plugin, depois de receber o token no seu listener local (localhost:52857),
// redireciona o navegador para ca. E uma pagina do site, estilizada e hospedada,
// no lugar do HTML cru que o proprio plugin servia antes.
//
// Nao recebe nem exibe o token: ele fica no plugin. Aqui so confirmamos que a
// autenticacao terminou e convidamos o usuario a voltar ao AutoCAD.
const PluginConnected = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Plugin conectado — RNPlugin</title>
      </Helmet>

      <div className="flex items-center justify-center min-h-screen bg-rn-bg px-4">
        <Card className="w-full max-w-md p-8 text-center" hover={false}>
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <svg
              className="h-9 w-9 text-green-600"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-2xl font-semibold text-rn-navy mb-3">
            Autenticação concluída
          </h1>
          <p className="text-rn-text-soft mb-8">
            Sua conta foi conectada ao plugin. Volte ao AutoCAD para continuar —
            já pode fechar esta aba.
          </p>

          <div className="space-y-3">
            <Link to="/dashboard">
              <Button variant="secondary" className="w-full">
                Ir para o meu painel
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </>
  );
};

export default PluginConnected;
